import moment from "moment";
import { convertToPercent, daysCountFromRange, deepCopy, getAppData, getDatesInRange, getFromState, getObjectFilter, getTransformedSegments, in_array, round, setUpDate, checkProperValue, getAdrValue, getCorrectValue, getDayDateKey } from "../../../app/util";
import { useDataSummary } from "../../Tile/kpiService";
import dataService from "../../../services/data.service";
import { useSelector } from "react-redux";
import { transformSegmentData } from "../segmentedData";
import { getSegmentedCode } from "../processDataReports";

export function getPickupReportData_hotel(columns, auth, app_state, ui_state) {
    let inputData = (app_state.workspace_controls.segmented_view) ? [] : deepCopy(dataService.getSeriesById("OSR").data.data);
    let marketData = (dataService.getSeriesById("MarketARISegmented").data) ? deepCopy(dataService.getSeriesById("MarketARISegmented").data.data) : [];

    const { active_tiles, table_filters } = ui_state;
    const { dayDate } = app_state.workspace_controls;
    const useVarCapacity = !!(ui_state.showVariableCapacity);

    const filteredDow = table_filters.table_reports.dow.map(d => d.code);
    // data = data.filter((item) => filteredDow.includes(moment(item.index.date).format('ddd').toLocaleLowerCase()));
    // marketData = marketData.filter((item) => filteredDow.includes(moment(item.index.date).format('ddd').toLocaleLowerCase()));
    let setup_data = [];
    if (inputData && inputData.length) {
        inputData.forEach((dataSet, index) => {
            let k = Object.keys(dataSet);
            if (k.includes("Segment_UNMAPPED")) {
                let hotelKeys = Object.keys(dataSet.HotelTotal);
                hotelKeys.forEach(element => {
                    inputData[index]['HotelTotal'][element]['Rooms'] = inputData[index]['HotelTotal'][element]['Rooms'] - getCorrectValue(inputData[index]['Segment_UNMAPPED'][element]['Rooms']);
                    inputData[index]['HotelTotal'][element]['Occ'] = inputData[index]['HotelTotal'][element]['Occ'] - getCorrectValue(inputData[index]['Segment_UNMAPPED'][element]['Occ']);
                    inputData[index]['HotelTotal'][element]['ADR'] = inputData[index]['HotelTotal'][element]['ADR'] - getCorrectValue(inputData[index]['Segment_UNMAPPED'][element]['ADR']);
                    inputData[index]['HotelTotal'][element]['RevPAR'] = inputData[index]['HotelTotal'][element]['RevPAR'] - getCorrectValue(inputData[index]['Segment_UNMAPPED'][element]['RevPAR']);
                    inputData[index]['HotelTotal'][element]['Revenue'] = inputData[index]['HotelTotal'][element]['Revenue'] - getCorrectValue(inputData[index]['Segment_UNMAPPED'][element]['Revenue']);
                    inputData[index]['HotelTotal'][element]['SellRate'] = inputData[index]['HotelTotal'][element]['SellRate'] - getCorrectValue(inputData[index]['Segment_UNMAPPED'][element]['SellRate']);

                    let roomData = inputData[index]['HotelTotal'][element]['Rooms'];//- getCorrectValue(inputData[index]['Segment_UNMAPPED'][element]['Rooms']);
                    let revenueData = inputData[index]['HotelTotal'][element]['Revenue'];// - getCorrectValue(inputData[index]['Segment_UNMAPPED'][element]['Revenue']);
                    inputData[index]['HotelTotal'][element]['ADR'] = revenueData / roomData;
                    // debugger;

                });
            }
        });
    }
    let data = inputData;
    const osrSegmentData = dataService.getSeriesById("OSRSegment")?.data?.data || [];

    if (data) {
        let dataKey = "HotelTotal";
        let dataKey1 = (app_state.workspace_controls.pickUpType) === "Standard" ? "current" : "primary";
        let dataKey2 = (app_state.workspace_controls.pickUpType) === "Standard" ? "prior" : "pickup";

        data.map((item, index) => {
            const osrSegItem = osrSegmentData.find(x => moment(x.index?.date).format('YYYY-MM-DD') === moment(item.index.date).format('YYYY-MM-DD'));
            const osrSegHT = osrSegItem?.HotelTotal;
            let data_columns = [];
            columns.map(col => {
                let dataObj = {};
                if (col.type === 'dateColumn') {
                    dataObj = setUpDate(dataObj, item.index.date);
                    if (app_state.workspace_controls.segmented_view) {
                        dataObj["segment"] = item.index.segment;
                    }
                }

                if (col.type === 'dataColumn') {
                    let { mainKey } = col;
                    col.subcolumns.map(key => {
                        if (item && mainKey === "variance_pickup") {
                            const vCapVC = item[dataKey][dataKey1]?.VCapacity || osrSegHT?.primary?.VCapacity;
                            const vcap = useVarCapacity ? (vCapVC || item[dataKey][dataKey1]?.Capacity || osrSegHT?.primary?.Capacity) : null;
                            const vCap = vCapVC || item[dataKey][dataKey2]?.Capacity || osrSegHT?.primary?.Capacity;
                            const vCap1 = useVarCapacity ? item[dataKey][dataKey1]?.VCapacity || item[dataKey][dataKey1]?.Capacity || osrSegHT?.primary?.Capacity : null;
                            const vCap2 = useVarCapacity ? item[dataKey][dataKey2]?.VCapacity || item[dataKey][dataKey2]?.Capacity || osrSegHT?.primary?.Capacity : null;

                            if (key.value === "ADR") {
                                let revenue = item[dataKey][dataKey1].Revenue - item[dataKey][dataKey2].Revenue;
                                let rooms = item[dataKey][dataKey1].Rooms - item[dataKey][dataKey2].Rooms;
                                dataObj[key.value] = getAdrValue(revenue, rooms, 'f');
                            } else if (key.value === "Occ") {
                                if (useVarCapacity) {
                                    let occKey1 = item[dataKey][dataKey1].Rooms / vCap1;
                                    let occKey2 = item[dataKey][dataKey2].Rooms / vCap2;
                                    dataObj[key.value] = convertToPercent(occKey1 - occKey2);
                                } else {
                                    dataObj[key.value] = convertToPercent(item[dataKey][dataKey1][key.value] - item[dataKey][dataKey2][key.value]);
                                }
                                if (vCap) {
                                    dataObj._vcap = useVarCapacity ? vCap : (item[dataKey][dataKey1]?.Capacity || osrSegHT?.primary?.Capacity);
                                    // Indicator shows only when the fixed-vs-variable capacity GAP itself
                                    // differs between the two pickup snapshots — not just whenever either
                                    // snapshot alone has a fixed/variable mismatch (that would fire on nearly
                                    // every date and defeat the point of a "changed" indicator).
                                    const cap1 = item[dataKey][dataKey1]?.Capacity;
                                    const vc1 = item[dataKey][dataKey1]?.VCapacity;
                                    const cap2 = item[dataKey][dataKey2]?.Capacity;
                                    const vc2 = item[dataKey][dataKey2]?.VCapacity;
                                    const allNumbers = [cap1, vc1, cap2, vc2].every(v => typeof v === 'number');
                                    dataObj._vcapDiffers = allNumbers && ((cap1 - vc1) !== (cap2 - vc2));
                                    dataObj._vcapLabel = 'Variable Capacity';
                                }
                            } else if (key.value === 'RevPAR') {
                                let revparKey1 = item[dataKey][dataKey1].Revenue / vCap1;
                                let revparKey2 = item[dataKey][dataKey2].Revenue / vCap2;
                                dataObj[key.value] = round(item[dataKey][dataKey1][key.value] - item[dataKey][dataKey2][key.value]);
                                if (useVarCapacity) {
                                    dataObj[key.value] = round(revparKey1 - revparKey2);
                                }
                            } else if (key.value === 'Available') {
                                const avail1 = vCap1 ? round(vCap1 - item[dataKey][dataKey1].Rooms) : null;
                                const avail2 = vCap2 ? round(vCap2 - item[dataKey][dataKey2].Rooms) : null;
                                dataObj[key.value] = (avail1 !== null && avail2 !== null) ? round(avail1 - avail2) : 0;
                            } else {
                                dataObj[key.value] = round(item[dataKey][dataKey1][key.value] - item[dataKey][dataKey2][key.value]);
                            }
                        } else if (mainKey === "difference_sdly") {
                            let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
                            if (key.value === "Occ") {
                                dataObj[key.value] = convertToPercent(item[dataKey][dataKey1][key.value] - item[dataKey][dayDateKey][key.value])
                            } else {
                                dataObj[key.value] = round(item[dataKey][dataKey1][key.value] - item[dataKey][dayDateKey][key.value])
                            }
                        } else if (mainKey === "sdly_pickup_diff") {
                            let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
                            let dayDate_sdly_actual = (dayDate === "day") ? "sdly_actual" : "sdtly_actual";
                            const vcapSdly = useVarCapacity ? (item[dataKey][dayDateKey]?.VCapacity || item[dataKey][dayDateKey]?.Capacity || null) : null;
                            const vcapSdlyActual = useVarCapacity ? (item[dataKey][dayDate_sdly_actual]?.VCapacity || item[dataKey][dayDate_sdly_actual]?.Capacity || null) : null;
                            if (key.value === "Occ") {
                                const sdlyActualOcc = vcapSdlyActual ? item[dataKey][dayDate_sdly_actual].Rooms / vcapSdlyActual : item[dataKey][dayDate_sdly_actual][key.value];
                                const sdlyOcc = vcapSdly ? item[dataKey][dayDateKey].Rooms / vcapSdly : item[dataKey][dayDateKey][key.value];
                                dataObj[key.value] = convertToPercent(sdlyActualOcc - sdlyOcc);
                            } else if (key.value === "ADR") {
                                dataObj[key.value] = (item[dataKey][dayDate_sdly_actual]['Revenue'] / item[dataKey][dayDate_sdly_actual]['Rooms']) - (item[dataKey][dayDateKey]['Revenue'] / item[dataKey][dayDateKey]['Rooms']);
                            } else {
                                const sdlyActualVal = vcapSdlyActual && key.value === 'RevPAR' ? item[dataKey][dayDate_sdly_actual].Revenue / vcapSdlyActual : item[dataKey][dayDate_sdly_actual][key.value];
                                const sdlyVal = vcapSdly && key.value === 'RevPAR' ? item[dataKey][dayDateKey].Revenue / vcapSdly : item[dataKey][dayDateKey][key.value];
                                dataObj[key.value] = round(sdlyActualVal - sdlyVal);
                            }
                        } else if (mainKey === "marketprimary") {
                            if (key.value == "Occ") {
                                dataObj[key.value] = (marketData[index]) ? convertToPercent(marketData[index]["MarketTotal"]["primary"][key.value]) : 0.00;
                            } else {
                                dataObj[key.value] = (marketData[index]) ? round(marketData[index]["MarketTotal"]["primary"][key.value]) : 0.00;
                            }
                        } else if (mainKey === "marketsdly") {
                            if (key.value == "Occ") {
                                dataObj[key.value] = (marketData[index]) ? convertToPercent(marketData[index]["MarketTotal"]["sdly"][key.value]) : 0.00;
                            } else {
                                dataObj[key.value] = (marketData[index]) ? round(marketData[index]["MarketTotal"]["sdly"][key.value]) : 0.00;
                            }
                        } else if (mainKey === "market_sdly_diff") {
                            if (key.value === "Occ") {
                                dataObj[key.value] = (marketData[index]) ? convertToPercent(marketData[index]["MarketTotal"]["primary"][key.value] - marketData[index]["MarketTotal"]["sdly"][key.value]) : 0.00

                            } else {
                                dataObj[key.value] = (marketData[index]) ? round(marketData[index]["MarketTotal"]["primary"][key.value] - marketData[index]["MarketTotal"]["sdly"][key.value]) : 0.00
                            }
                        } else {
                            if (mainKey === "primary") {
                                mainKey = dataKey1;
                            } else if (mainKey === "pickup") {
                                mainKey = dataKey2;
                            } else {
                                mainKey = mainKey;
                            }
                            mainKey = getDayDateKey(dayDate, mainKey);
                            const vcap = useVarCapacity ? (item[dataKey][mainKey]?.VCapacity || item[dataKey][mainKey]?.Capacity || null) : null;
                            const vCap = item[dataKey][mainKey]?.VCapacity || item[dataKey][mainKey]?.Capacity;
                            if (key.value == "Occ") {
                                dataObj[key.value] = vcap
                                    ? convertToPercent(item[dataKey][mainKey].Rooms / vcap)
                                    : convertToPercent(item[dataKey][mainKey][key.value]);
                                if (vCap) {
                                    dataObj._vcap = useVarCapacity ? vCap : item[dataKey][mainKey]?.Capacity;
                                    dataObj._vcapLabel = (useVarCapacity && item[dataKey][mainKey]?.VCapacity) ? 'Variable Capacity' : 'Capacity';
                                    dataObj._vcapDiffers = !!(item[dataKey][mainKey]?.VCapacity && item[dataKey][mainKey]?.VCapacity !== item[dataKey][mainKey]?.Capacity);
                                }
                            } else if (key.value === 'Available') {
                                const rooms = item[dataKey]?.[mainKey]?.Rooms;
                                // prior/pickup key may lack VCapacity in API; fall back to today's capacity
                                const effectiveVcap = vcap || (useVarCapacity ? (
                                    item[dataKey][dataKey1]?.VCapacity || item[dataKey][dataKey1]?.Capacity || null
                                ) : null);
                                dataObj[key.value] = (effectiveVcap && rooms !== undefined) ? round(effectiveVcap - rooms) : 0;
                            } else {
                                dataObj[key.value] = vcap && key.value === 'RevPAR'
                                    ? round(item[dataKey][mainKey].Revenue / vcap)
                                    : round(item[dataKey][mainKey][key.value]);
                            }
                        }
                    })
                }
                dataObj.id = col.id;
                data_columns.push(dataObj);
            })

            data_columns.map((itmArr, idx) => {
                if (itmArr['date'] == "" || itmArr['segment'] === "Total") {
                    data_columns[idx]["ignore_sort"] = true;
                }
            })
            setup_data.push(data_columns);
        })
    }
    return setup_data;

}


export function getTopSegments(auth, app_state, category) {
    let system_settings = getAppData(auth, app_state)
    let market_segment_category_mapping = system_settings.market_segment_category_mapping;
    const lvl1_mseg_grouping = JSON.parse(
        JSON.stringify(system_settings.lvl1_mseg_grouping)
    );
    const topSegments = {};
    lvl1_mseg_grouping.filter((item) => {
        if (item.Transient) topSegments.Transient = item.Transient;
        if (item.Group) topSegments.Group = item.Group;
        if (item.Contract) topSegments.Contract = item.Contract;
    });
    let segmentCodes = [];
    let topSegmentsList = topSegments[category];
    if (topSegmentsList) {
        topSegmentsList.map((item) => {
            if (market_segment_category_mapping[item]) {
                segmentCodes = [...segmentCodes, item];
            }
        })
        segmentCodes = [...new Set(segmentCodes)];
    }
    return segmentCodes;
}

export function getTopSegments_xx(auth, app_state, category) {
    let system_settings = getAppData(auth, app_state)
    let market_segment_category_mapping = system_settings.market_segment_category_mapping;
    const lvl1_mseg_grouping = JSON.parse(
        JSON.stringify(system_settings.lvl1_mseg_grouping)
    );
    const topSegments = {};
    lvl1_mseg_grouping.filter((item) => {
        if (item.Transient) topSegments.Transient = item.Transient;
        if (item.Group) topSegments.Group = item.Group;
        if (item.Contract) topSegments.Contract = item.Contract;
    });
    // debugger;
    let segmentCodes = [];
    let topSegmentsList = topSegments[category];
    if (topSegmentsList) {
        topSegmentsList.map((item) => {
            if (market_segment_category_mapping[item]) {
                segmentCodes = [...segmentCodes, ...market_segment_category_mapping[item]];
            }
        })
        segmentCodes = [...new Set(segmentCodes)];
    }
    return segmentCodes;
}


export function getPickupReportSegmentedData_hotel(columns, auth, app_state, ui_state) {
    let data = deepCopy(dataService.getSeriesById("OSRSegment").data.data);
    let marketData = (dataService.getSeriesById("MarketARISegmented").data) ? deepCopy(dataService.getSeriesById("MarketARISegmented").data.data) : [];
    let setup_data = [];
    let { date_from, date_until } = app_state.primary_stay_range;
    const { dayDate } = app_state.workspace_controls;
    const useVarCapacity = !!(ui_state.showVariableCapacity);
    const osrData = dataService.getSeriesById("OSR")?.data?.data || [];
    let categoryList = ["Transient", "Group", "Contract", "Total"];
    const { active_tiles, table_filters } = ui_state;
    const filteredDow = table_filters.table_reports.dow.map(d => d.code);
    let dates = getDatesInRange(date_from, date_until);
    let dataKey1 = (app_state.workspace_controls.pickUpType) === "Standard" ? "current" : "primary";
    let dataKey2 = (app_state.workspace_controls.pickUpType) === "Standard" ? "prior" : "pickup";

    /////// final Total /////
    let blankObj = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let primaryTotal = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let sdlyTotal = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let sdly_actualTotal = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let sdlyText = (dayDate === 'day') ? "otb_sdly" : "sdtly";
    let allTotal = {
        "Transient": {
            "variance_pickup": deepCopy(blankObj),
            "otb_primary_report": deepCopy(blankObj),
            "current": deepCopy(blankObj),
            "prior": deepCopy(blankObj),
            "otb_pickup_report": deepCopy(blankObj),
            // "sdly": deepCopy(blankObj),
            [sdlyText]: deepCopy(blankObj),
            // "sdtly_actual": deepCopy(blankObj),
            // "sdtly_pickup": deepCopy(blankObj),
            "market_report": deepCopy(blankObj),
            "market_sdly_report": deepCopy(blankObj),
            "market_sdly_diff_report": deepCopy(blankObj),

        },
        "Group": {
            "variance_pickup": deepCopy(blankObj),
            "otb_primary_report": deepCopy(blankObj),
            "current": deepCopy(blankObj),
            "prior": deepCopy(blankObj),
            "otb_pickup_report": deepCopy(blankObj),
            [sdlyText]: deepCopy(blankObj),
            // "sdtly": deepCopy(blankObj),
            // "sdtly_actual": deepCopy(blankObj),
            // "sdtly_pickup": deepCopy(blankObj),
            "market_report": deepCopy(blankObj),
            "market_sdly_report": deepCopy(blankObj),
            "market_sdly_diff_report": deepCopy(blankObj),

        },
        "Contract": {
            "variance_pickup": deepCopy(blankObj),
            "otb_primary_report": deepCopy(blankObj),
            "current": deepCopy(blankObj),
            "prior": deepCopy(blankObj),
            "otb_pickup_report": deepCopy(blankObj),
            [sdlyText]: deepCopy(blankObj),
            // "sdtly": deepCopy(blankObj),
            // "sdtly_actual": deepCopy(blankObj),
            // "sdtly_pickup": deepCopy(blankObj),
            "market_report": deepCopy(blankObj),
            "market_sdly_report": deepCopy(blankObj),
            "market_sdly_diff_report": deepCopy(blankObj),

        },

    }

    if (app_state.workspace_controls.pickUpType === "Standard") {
        delete allTotal.Contract.primary;
        delete allTotal.Transient.primary;
        delete allTotal.Group.primary;
        delete allTotal.Contract.pickup;
        delete allTotal.Transient.pickup;
        delete allTotal.Group.pickup;
    }
    if (app_state.workspace_controls.pickUpType === "Latest") {
        delete allTotal.Contract.current;
        delete allTotal.Transient.current;
        delete allTotal.Group.current;
        delete allTotal.Contract.prior;
        delete allTotal.Transient.prior;
        delete allTotal.Group.prior;
    }

    ///// end final total //// 
    let totalDays = daysCountFromRange(app_state);
    if (dates && dates.length > 0) {

        dates.map((date, dateIndex) => {
            const osrItem = osrData.find(x => moment(x.index?.date).format('YYYY-MM-DD') === date);
            const osrHT = osrItem?.HotelTotal;
            const htSegItem = data.find(x => moment(x.index?.date).format('YYYY-MM-DD') === date);
            const htSegHT = htSegItem?.HotelTotal;

            categoryList.map((category, categoryIndex) => {
                let data_columns = [];
                let segmentCodes = getTopSegments(auth, app_state, category);

                columns.map(col => {
                    let dataObj = {};
                    dataObj.id = col.id;
                    if (col.type === 'dateColumn') {
                        dataObj = setUpDate(dataObj, date);
                        if (app_state.workspace_controls.segmented_view) {
                            dataObj["segment"] = category;
                            // dataObj["segment"] = (categoryIndex == (categoryList.length - 1)) ? "Total" : category ;
                        }
                    }
                    if (col.type === 'dataColumn') {
                        let { mainKey, id } = col;
                        col.subcolumns.map(key => {
                            if (mainKey === "variance_pickup") {
                                const vCapVC = htSegHT?.primary?.VCapacity || osrHT?.primary?.VCapacity;
                                const vcap = useVarCapacity ? (vCapVC || htSegHT?.primary?.Capacity || osrHT?.primary?.Capacity) : null;
                                const vCap = vCapVC || htSegHT?.primary?.Capacity || osrHT?.primary?.Capacity;
                                let keyPrimaryTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, segmentCodes, dataKey1, "osr", category);
                                let keyPickupTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, segmentCodes, dataKey2, "osr", category);

                                let keysTotal_primary = getSegmentKeyTotal(data[dateIndex], key.value, segmentCodes, dataKey1, "osr", category);
                                let keysTotalpickup = getSegmentKeyTotal(data[dateIndex], key.value, segmentCodes, dataKey2, "osr", category);

                                let vCap1 = data[dateIndex].HotelTotal[dataKey1]?.VCapacity;
                                let vCap2 = data[dateIndex].HotelTotal[dataKey2]?.VCapacity;
                                let Cap1 = data[dateIndex].HotelTotal[dataKey1]?.Capacity;
                                let Cap2 = data[dateIndex].HotelTotal[dataKey2]?.Capacity;

                                if (key.value === "ADR") {
                                    // For Total category segmentCodes is empty — use HotelTotal directly
                                    const htRevAdj = category === 'Total'
                                        ? (data[dateIndex]?.HotelTotal?.[dataKey1]?.Revenue || 0) - (data[dateIndex]?.HotelTotal?.[dataKey2]?.Revenue || 0)
                                        : getSegmentKeyTotal(data[dateIndex], 'Revenue', segmentCodes, dataKey1, "osr", category) - getSegmentKeyTotal(data[dateIndex], 'Revenue', segmentCodes, dataKey2, "osr", category);
                                    const htRoomsAdj = category === 'Total'
                                        ? (data[dateIndex]?.HotelTotal?.[dataKey1]?.Rooms || 0) - (data[dateIndex]?.HotelTotal?.[dataKey2]?.Rooms || 0)
                                        : getSegmentKeyTotal(data[dateIndex], 'Rooms', segmentCodes, dataKey1, "osr", category) - getSegmentKeyTotal(data[dateIndex], 'Rooms', segmentCodes, dataKey2, "osr", category);
                                    dataObj[key.value] = getAdrValue(htRevAdj, htRoomsAdj, 'f');
                                    if (category !== "Total") {
                                        allTotal[category][id][key.value] += (in_array([key.value], ['Rooms', 'Revenue'])) ? keysTotal_primary - keysTotalpickup : ((keysTotal_primary - keysTotalpickup) / totalDays);
                                    }
                                } else if (key.value === "Occ") {
                                    if (category === 'Total') {
                                        if (useVarCapacity) {
                                            const roomsPrimary = data[dateIndex]?.HotelTotal?.[dataKey1]?.Rooms || 0;
                                            const roomsPickup = data[dateIndex]?.HotelTotal?.[dataKey2]?.Rooms || 0;
                                            const occCurrent = roomsPrimary / vCap1 || 0;
                                            const occPrior = roomsPickup / vCap2 || 0;
                                            dataObj[key.value] = convertToPercent(occCurrent - occPrior);
                                        } else {
                                            const occCurrent = data[dateIndex]?.HotelTotal?.[dataKey1]?.Occ || 0;
                                            const occPrior = data[dateIndex]?.HotelTotal?.[dataKey2]?.Occ || 0;
                                            dataObj[key.value] = convertToPercent(occCurrent - occPrior);
                                        }
                                    } else {
                                        if (useVarCapacity) {
                                            let roomsCurrent = getSegmentKeyTotal(data[dateIndex], 'Rooms', segmentCodes, dataKey1, "osr", category);
                                            let roomsPrior = getSegmentKeyTotal(data[dateIndex], 'Rooms', segmentCodes, dataKey2, "osr", category);
                                            const occCurrent = roomsCurrent / vCap1 || 0;
                                            const occPrior = roomsPrior / vCap2 || 0;
                                            dataObj[key.value] = convertToPercent(occCurrent - occPrior);
                                        } else {
                                            let occCurrent = getSegmentKeyTotal(data[dateIndex], 'Occ', segmentCodes, dataKey1, "osr", category);
                                            let occPrior = getSegmentKeyTotal(data[dateIndex], 'Occ', segmentCodes, dataKey2, "osr", category);
                                            dataObj[key.value] = convertToPercent(occCurrent - occPrior);
                                        }

                                    }
                                    if (category === 'Total') {
                                        // Mirror getPickupReportData_hotel's EXACT _vcap fallback chain (dataKey1
                                        // VCapacity first, hardcoded-.primary as a last-resort fallback only —
                                        // never the primary source) instead of this function's old top-level
                                        // `vCap`, which used the hardcoded .primary key as its ONLY source and
                                        // resolved to undefined under "Standard" pickUpType (real keys are
                                        // current/prior there). An undefined _vcap fails TableReports.js's
                                        // carry-forward guard (`item[i]._vcap !== undefined`), so _vcapDiffers
                                        // never survived onto the rebuilt Total row — indicator silently
                                        // vanished in Segment mode even though Hotel mode worked fine.
                                        //
                                        // Also, unlike the earlier version, this is NOT gated on useVarCapacity —
                                        // getPickupReportData_hotel gates only on `if (vCap)`, never the toggle.
                                        // The capacity-gap-changed fact is a property of the DATA (did OOO/OOS
                                        // change between the two pickup snapshots), independent of whether the
                                        // user is currently viewing Occ/RevPAR computed with fixed or variable
                                        // capacity — the toggle should only affect those calculated values
                                        // (handled separately above), never the indicator's own visibility.
                                        const htVCapVC = data[dateIndex]?.HotelTotal?.[dataKey1]?.VCapacity || osrHT?.primary?.VCapacity;
                                        const htVCap = htVCapVC || data[dateIndex]?.HotelTotal?.[dataKey2]?.Capacity || osrHT?.primary?.Capacity;
                                        if (htVCap) {
                                            dataObj._vcap = useVarCapacity ? htVCap : (data[dateIndex]?.HotelTotal?.[dataKey1]?.Capacity || osrHT?.primary?.Capacity);
                                            // Indicator shows only when the fixed-vs-variable capacity GAP itself
                                            // differs between the two pickup snapshots — see getPickupReportData_hotel
                                            // for the same rule on the non-segmented Hotel data level.
                                            const cap1 = data[dateIndex]?.HotelTotal?.[dataKey1]?.Capacity;
                                            const vc1 = data[dateIndex]?.HotelTotal?.[dataKey1]?.VCapacity;
                                            const cap2 = data[dateIndex]?.HotelTotal?.[dataKey2]?.Capacity;
                                            const vc2 = data[dateIndex]?.HotelTotal?.[dataKey2]?.VCapacity;
                                            const allNumbers = [cap1, vc1, cap2, vc2].every(v => typeof v === 'number');
                                            dataObj._vcapDiffers = allNumbers && ((cap1 - vc1) !== (cap2 - vc2));
                                            dataObj._vcapLabel = 'Variable Capacity';
                                        }
                                    }
                                    if (category !== "Total") {
                                        // allTotal[category][id][key.value] += convertToPercent(((keysTotal_primary - keysTotalpickup) / totalDays));
                                    }
                                } else if (key.value === 'RevPAR') {
                                    if (category === 'Total') {
                                        if (useVarCapacity) {
                                            const revenuePrimary = data[dateIndex]?.HotelTotal?.[dataKey1]?.Revenue || 0;
                                            const revenuePickup = data[dateIndex]?.HotelTotal?.[dataKey2]?.Revenue || 0;
                                            const revparCurrent = revenuePrimary / vCap1 || 0;
                                            const revparPrior = revenuePickup / vCap2 || 0;
                                            dataObj[key.value] = round(revparCurrent - revparPrior);
                                        } else {
                                            const revenuePrimary = getSegmentKeyTotal(data[dateIndex], 'Revenue', segmentCodes, dataKey1, "osr", category);;
                                            const revenuePickup = getSegmentKeyTotal(data[dateIndex], 'Revenue', segmentCodes, dataKey2, "osr", category);
                                            const revparCurrent = revenuePrimary / Cap1 || 0;
                                            const revparPrior = revenuePickup / Cap2 || 0;
                                            dataObj[key.value] = round(revparCurrent - revparPrior);
                                        }
                                    } else {
                                        if (useVarCapacity) {
                                            const revenuePrimary = getSegmentKeyTotal(data[dateIndex], 'Revenue', segmentCodes, dataKey1, "osr", category);
                                            const revenuePickup = getSegmentKeyTotal(data[dateIndex], 'Revenue', segmentCodes, dataKey2, "osr", category);
                                            const revparCurrent = revenuePrimary / vCap1 || 0;
                                            const revparPrior = revenuePickup / vCap2 || 0;
                                            dataObj[key.value] = round(revparCurrent - revparPrior);
                                        } else {
                                            const revenuePrimary = getSegmentKeyTotal(data[dateIndex], 'Revenue', segmentCodes, dataKey1, "osr", category);
                                            const revenuePickup = getSegmentKeyTotal(data[dateIndex], 'Revenue', segmentCodes, dataKey2, "osr", category);
                                            const revparCurrent = revenuePrimary / Cap1 || 0;
                                            const revparPrior = revenuePickup / Cap2 || 0;
                                            dataObj[key.value] = round(revparCurrent - revparPrior);
                                        }
                                    }
                                    if (category !== "Total") {
                                        allTotal[category][id][key.value] += (in_array([key.value], ['Rooms', 'Revenue'])) ? keysTotal_primary - keysTotalpickup : ((keysTotal_primary - keysTotalpickup) / totalDays);
                                    }
                                } else if (key.value === 'Available') {
                                    // 1 Day Pickup Available = Available(pickup snapshot) − Available(prior
                                    // snapshot), computed the same way the otb_primary_report / otb_pickup_report
                                    // columns compute their own Available (HotelTotal Rooms directly for Total,
                                    // since segmentCodes is always [] for 'Total' — see the generic branch above).
                                    const effVCap1 = useVarCapacity ? (vCap1 || Cap1) : Cap1;
                                    const effVCap2 = useVarCapacity ? (vCap2 || Cap2) : Cap2;
                                    const rooms1 = category === 'Total'
                                        ? (data[dateIndex]?.HotelTotal?.[dataKey1]?.Rooms ?? osrHT?.[dataKey1]?.Rooms)
                                        : getSegmentKeyTotal(data[dateIndex], 'Rooms', segmentCodes, dataKey1, "osr", category);
                                    const rooms2 = category === 'Total'
                                        ? (data[dateIndex]?.HotelTotal?.[dataKey2]?.Rooms ?? osrHT?.[dataKey2]?.Rooms)
                                        : getSegmentKeyTotal(data[dateIndex], 'Rooms', segmentCodes, dataKey2, "osr", category);
                                    const avail1 = (effVCap1 && rooms1 !== undefined) ? round(effVCap1 - rooms1) : null;
                                    const avail2 = (effVCap2 && rooms2 !== undefined) ? round(effVCap2 - rooms2) : null;
                                    dataObj[key.value] = (avail1 !== null && avail2 !== null) ? round(avail1 - avail2) : 0;
                                    if (category === 'Total' && effVCap1 && effVCap2) {
                                        // The segmented-view Total row gets rebuilt downstream (TableReports.js
                                        // getTotalData) by summing Transient/Group/Contract — that rebuild
                                        // discards this inline value entirely and instead recomputes Available
                                        // as `_vcap - Rooms`. Without this, `_vcap` is left holding whatever the
                                        // Occ branch above set it to for its own (unrelated) purposes — a single
                                        // snapshot's capacity, not a capacity *difference* — which silently
                                        // produced the wrong pickup-diff Available. Overwrite it with the
                                        // correct differential capacity so that downstream recompute lands here.
                                        dataObj._vcap = round(effVCap1 - effVCap2);
                                    }
                                } else {
                                    dataObj[key.value] = round(keyPrimaryTotalValue - keyPickupTotalValue);
                                    if (category !== "Total") {
                                        allTotal[category][id][key.value] += (in_array([key.value], ['Rooms', 'Revenue'])) ? keysTotal_primary - keysTotalpickup : ((keysTotal_primary - keysTotalpickup) / totalDays);
                                    }
                                }
                            } else if (mainKey === "difference_sdly") {
                                let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
                                let keyPrimaryTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, segmentCodes, dataKey1, "osr", category);
                                let keySdlyTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, segmentCodes, dayDateKey, "osr", category);

                                if (key.value === "Occ") {
                                    dataObj[key.value] = convertToPercent(keyPrimaryTotalValue - keySdlyTotalValue)
                                } else {
                                    dataObj[key.value] = round(keyPrimaryTotalValue - keySdlyTotalValue)
                                }
                            } else if (mainKey === "sdly_pickup_diff") {
                                let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
                                let dayDate_sdly_actual = (dayDate === "day") ? "sdly_actual" : "sdtly_actual";
                                const vcapSdly = useVarCapacity ? (osrHT?.[dayDateKey]?.VCapacity || osrHT?.[dayDateKey]?.Capacity || null) : null;
                                const vcapSdlyActual = useVarCapacity ? (osrHT?.[dayDate_sdly_actual]?.VCapacity || osrHT?.[dayDate_sdly_actual]?.Capacity || null) : null;

                                let keySdlyActualTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, segmentCodes, dayDate_sdly_actual, "osr", category);
                                let keySdlyTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, segmentCodes, dayDateKey, "osr", category);

                                let keysTotal_sdly_actual = getSegmentKeyTotal(data[dateIndex], key.value, segmentCodes, dayDate_sdly_actual, "osr", category);
                                let keysTotalSdly = getSegmentKeyTotal(data[dateIndex], key.value, segmentCodes, dayDateKey, "osr", category);

                                if (key.value === "Occ") {
                                    const sdlyActualOcc = vcapSdlyActual
                                        ? getSegmentKeyTotal(data[dateIndex], 'Rooms', segmentCodes, dayDate_sdly_actual, "osr", category) / vcapSdlyActual
                                        : keySdlyActualTotalValue;
                                    const sdlyOcc = vcapSdly
                                        ? getSegmentKeyTotal(data[dateIndex], 'Rooms', segmentCodes, dayDateKey, "osr", category) / vcapSdly
                                        : keySdlyTotalValue;
                                    dataObj[key.value] = convertToPercent(sdlyActualOcc - sdlyOcc);
                                } else {
                                    const sdlyActualVal = vcapSdlyActual && key.value === 'RevPAR'
                                        ? getSegmentKeyTotal(data[dateIndex], 'Revenue', segmentCodes, dayDate_sdly_actual, "osr", category) / vcapSdlyActual
                                        : keySdlyActualTotalValue;
                                    const sdlyVal = vcapSdly && key.value === 'RevPAR'
                                        ? getSegmentKeyTotal(data[dateIndex], 'Revenue', segmentCodes, dayDateKey, "osr", category) / vcapSdly
                                        : keySdlyTotalValue;
                                    dataObj[key.value] = round(sdlyActualVal - sdlyVal);
                                }
                                if (category !== "Total") {
                                    allTotal[category][id][key.value] += convertToPercent(((keysTotal_sdly_actual - keysTotalSdly) / totalDays));
                                }

                            }
                            else if (mainKey === "marketprimary") {
                                let keyTotalValue_market = 0;//getSegmentKeyTotal(marketData[index], key.value, segmentCodes, "primary","market");
                                if (key.value == "Occ") {
                                    dataObj[key.value] = convertToPercent(keyTotalValue_market);
                                } else {
                                    dataObj[key.value] = round(keyTotalValue_market);
                                }
                                if (category !== "Total") {
                                    allTotal[category][id][key.value] = 0;
                                }
                            } else if (mainKey === "marketsdly") {
                                let keyTotalValueSdly_market = 0;// getSegmentKeyTotal(marketData[index], key.value, segmentCodes, "primary","market");

                                if (key.value == "Occ") {
                                    dataObj[key.value] = convertToPercent(keyTotalValueSdly_market);
                                } else {
                                    dataObj[key.value] = round(keyTotalValueSdly_market);
                                }
                                if (category !== "Total") {
                                    allTotal[category][id][key.value] = 0;
                                }
                            } else if (mainKey === "market_sdly_diff") {
                                let keyTotalValue_market = 0;//getSegmentKeyTotal(marketData[index], key.value, segmentCodes, "primary","market");
                                let keyTotalValueSdly_market = 0;//getSegmentKeyTotal(marketData[index], key.value, segmentCodes, "primary","market");
                                dataObj[key.value] = round(keyTotalValue_market - keyTotalValueSdly_market);
                                if (category !== "Total") {
                                    allTotal[category][id][key.value] = 0;
                                }
                            }
                            else {
                                if (mainKey === "primary") {
                                    mainKey = dataKey1;
                                } else if (mainKey === "pickup") {
                                    mainKey = dataKey2;
                                } else {
                                    mainKey = mainKey;
                                }
                                mainKey = getDayDateKey(dayDate, mainKey);
                                let keyTotalValue = getSegmentKeyTotal(data[dateIndex], key.value, segmentCodes, mainKey, "osr", category);
                                let keysTotal = getSegmentKeyTotal(data[dateIndex], key.value, segmentCodes, mainKey, "osr", category);
                                const vCapVC = htSegHT?.[mainKey]?.VCapacity || osrHT?.[mainKey]?.VCapacity;
                                const vcap = useVarCapacity ? (vCapVC || htSegHT?.[mainKey]?.Capacity || osrHT?.[mainKey]?.Capacity) : null;
                                const vCap = vCapVC || htSegHT?.[mainKey]?.Capacity || osrHT?.[mainKey]?.Capacity;
                                if (key.value == "Occ") {
                                    if (vcap) {
                                        const totalRooms = getSegmentKeyTotal(data[dateIndex], 'Rooms', segmentCodes, mainKey, "osr", category);
                                        dataObj[key.value] = convertToPercent(totalRooms / vcap);
                                    } else {
                                        dataObj[key.value] = convertToPercent(keyTotalValue);
                                    }
                                    if (vCap && category === 'Total') {
                                        dataObj._vcap = useVarCapacity ? vCap : (htSegHT?.[mainKey]?.Capacity || osrHT?.[mainKey]?.Capacity);
                                        dataObj._vcapLabel = (useVarCapacity && vCapVC) ? 'Variable Capacity' : 'Capacity';
                                        dataObj._vcapDiffers = !!(vCapVC && vCapVC !== (htSegHT?.[mainKey]?.Capacity || osrHT?.[mainKey]?.Capacity));
                                    }
                                    if (category !== "Total") {
                                        allTotal[category][id][key.value] += convertToPercent((keysTotal / totalDays));
                                    }
                                } else if (key.value === 'Available') {
                                    if (category === 'Total' && vcap) {
                                        const totalRooms = getSegmentKeyTotal(data[dateIndex], 'Rooms', segmentCodes, mainKey, "osr", category);
                                        dataObj[key.value] = round(vcap - totalRooms);
                                    } else {
                                        dataObj[key.value] = 0;
                                    }
                                } else {
                                    if (key.value === 'RevPAR') {
                                        const totalRevenue = getSegmentKeyTotal(data[dateIndex], 'Revenue', segmentCodes, mainKey, "osr", category);
                                        const capacityForRevPAR = vcap || htSegHT?.[mainKey]?.Capacity || osrHT?.[mainKey]?.Capacity;
                                        dataObj[key.value] = capacityForRevPAR ? round(totalRevenue / capacityForRevPAR) : round(keyTotalValue);
                                    } else {
                                        dataObj[key.value] = round(keyTotalValue);
                                    }
                                    if (category !== "Total") {
                                        allTotal[category][id][key.value] += (in_array([key.value], ['Rooms', 'Revenue'])) ? keysTotal : (keysTotal / totalDays);
                                    }
                                }
                            }
                        })
                    }
                    data_columns.push(dataObj);
                })
                setup_data.push(data_columns);
            })

        })
    }
    let totalResult = getAllTotalData(allTotal);
    totalResult.forEach((itm, idx) => {
        itm.forEach((element, index) => {
            // let diffVarianceIndex = element.findIndex((it) => it.id === "variance_pickup");
            // if (diffVarianceIndex >= 0) {
            let rsAdr = element.Revenue / element.Rooms;
            totalResult[idx][index].ADR = rsAdr;
            // }
        });



    })


    setup_data = setup_data.concat(totalResult);
    // debugger;
    // console.log("setup_data_combined ", setup_data);
    return setup_data;
}



function getAllTotalData(allTotal) {
    let keys = Object.keys(allTotal);
    let result = [];
    keys.map((item) => {
        let itemKeys = Object.keys(allTotal[item]);
        let totalArr = [];
        let obj = {};
        obj.segment = item;
        obj.date = "";
        obj.dow = "";
        obj.id = "staydates";
        totalArr.push(obj);

        itemKeys.map((mainKey, index) => {
            if (mainKey === 'sdly') {
                allTotal[item][mainKey]['id'] = "otb_sdly";
            } else {
                allTotal[item][mainKey]['id'] = mainKey;
            }
            totalArr.push(allTotal[item][mainKey]);
        })
        result.push(totalArr);
    })
    // debugger
    return result;
}



// function to calculate segmented data for individual category segment.

export function getPickupReportSegmentedData_topSegment(columns, auth, app_state, segmentCodes, ui_state, segments) {
    let data = deepCopy(dataService.getSeriesById("OSRSegment").data.data);
    let marketData = (dataService.getSeriesById("MarketARISegmented").data) ? deepCopy(dataService.getSeriesById("MarketARISegmented").data.data) : [];
    let setup_data = [];
    let { date_from, date_until } = app_state.primary_stay_range;
    const { dayDate } = app_state.workspace_controls;

    const { active_tiles, table_filters } = ui_state;
    const filteredDow = table_filters.table_reports.dow.map(d => d.code);
    const useVarCapacity = !!(ui_state.showVariableCapacity);

    let dates = getDatesInRange(date_from, date_until);
    let dataKey1 = (app_state.workspace_controls.pickUpType) === "Standard" ? "current" : "primary";
    let dataKey2 = (app_state.workspace_controls.pickUpType) === "Standard" ? "prior" : "pickup";

    let blankObj = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    if (dates && dates.length > 0) {
        let currentDate;
        let totalObj = {};
        dates.map((date, dateIndex) => {
            let totalObjData = {};
            let totalColumns = [];
            if (!currentDate) {
                currentDate = date;
            }
            totalObj = setUpDate(totalObj, date);
            totalObj["segment"] = "Total";
            let primaryRoomstotal = 0;
            let primaryRevenueTotal = 0;

            let dataRecord = data.filter((item) => moment(item.index.date).format("YYYY-MM-DD") === moment(date).format("YYYY-MM-DD"));

            //Remove ignored codes from segmentCodes list
            let currTabSegmentCodes = [];
            // debugger;
            segmentCodes.forEach((code) => {
                if (segments.arrUnique.includes(code)) {
                    let uniq = [...new Set(segments.marketSegments[code])];
                    // uniq.splice(0,1);
                    // currTabSegmentCodes = [...uniq];
                    currTabSegmentCodes.push(code);
                }
            });
            // currTabSegmentCodes.splice(0,1);
            currTabSegmentCodes.map((segmentCode, segmentIndex) => {
                let data_columns = [];
                let segmentName = segmentCode;
                let segmentKey = "Segment_" + segmentCode;
                columns.map(col => {
                    let { mainKey } = col;
                    let colId = col.id;
                    let dataObj = {};
                    dataObj.id = col.id;
                    if (col.type === 'dateColumn') {
                        dataObj = setUpDate(dataObj, date);
                        // if (app_state.workspace_controls.segmented_view) {
                        dataObj["segment"] = segmentCode; //segments.map[segmentCode];
                        // }
                        if (colId === "staydates") {
                            totalObjData[colId] = setUpDate(totalObjData, date);
                            totalObjData[colId]["segment"] = "Total";
                        }
                    }
                    if (dataRecord && dataRecord.length && !dataRecord[0][segmentKey]) {
                        let to = {};
                        let total = dataRecord[0].HotelTotal;
                        let identities = Object.keys(total);

                        identities.forEach((k) => {
                            to[k] = deepCopy(blankObj);
                        });
                        dataRecord[0][segmentKey] = to;
                        //  debugger;
                    }
                    if (col.type === 'dataColumn') {
                        totalObjData[colId] = (totalObjData[colId] && totalObjData[colId] !== 'undefined') ? totalObjData[colId] : { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };

                        col.subcolumns.map(key => {
                            if (mainKey === "variance_pickup") {
                                const _htVcapData1 = dataRecord[0]?.HotelTotal?.[dataKey1];
                                const _htVcapData2 = dataRecord[0]?.HotelTotal?.[dataKey2];
                                const vCap1 = _htVcapData1?.VCapacity;
                                const vCap2 = _htVcapData2?.VCapacity;
                                const Cap1 = _htVcapData1?.Capacity;
                                const Cap2 = _htVcapData2?.Capacity;
                                const vCap = vCap1 || Cap1;
                                if (key.value === "ADR") {
                                    let revenue = dataRecord[0][segmentKey][dataKey1].Revenue - dataRecord[0][segmentKey][dataKey2].Revenue;
                                    let rooms = dataRecord[0][segmentKey][dataKey1].Rooms - dataRecord[0][segmentKey][dataKey2].Rooms;
                                    dataObj[key.value] = getAdrValue(revenue, rooms, 'f');
                                } else if (key.value === "Occ") {
                                    if (useVarCapacity) {
                                        const occCurrent = vCap1 ? dataRecord[0][segmentKey][dataKey1].Rooms / vCap1 : 0;
                                        const occPrior = vCap2 ? dataRecord[0][segmentKey][dataKey2].Rooms / vCap2 : 0;
                                        dataObj[key.value] = convertToPercent(occCurrent - occPrior);
                                    } else {
                                        dataObj[key.value] = convertToPercent(dataRecord[0][segmentKey][dataKey1][key.value] - dataRecord[0][segmentKey][dataKey2][key.value]);
                                    }
                                    if (vCap) {
                                        dataObj._vcap = useVarCapacity ? vCap : Cap1;
                                        // _vcapDiffers intentionally omitted — suppresses VCap indicator on pickup column
                                    }
                                    totalObjData[colId][key.value] += dataObj[key.value];
                                } else if (key.value === "RevPAR") {
                                    if (useVarCapacity) {
                                        const revparCurrent = vCap1 ? dataRecord[0][segmentKey][dataKey1].Revenue / vCap1 : 0;
                                        const revparPrior = vCap2 ? dataRecord[0][segmentKey][dataKey2].Revenue / vCap2 : 0;
                                        dataObj[key.value] = round(revparCurrent - revparPrior);
                                    } else {
                                        const revparCurrent = Cap1 ? dataRecord[0][segmentKey][dataKey1].Revenue / Cap1 : 0;
                                        const revparPrior = Cap2 ? dataRecord[0][segmentKey][dataKey2].Revenue / Cap2 : 0;
                                        dataObj[key.value] = round(revparCurrent - revparPrior);
                                    }
                                    totalObjData[colId][key.value] += dataObj[key.value];
                                } else {
                                    dataObj[key.value] = round(dataRecord[0][segmentKey][dataKey1][key.value] - dataRecord[0][segmentKey][dataKey2][key.value]);
                                    totalObjData[colId][key.value] += dataObj[key.value];
                                }
                            } else if (mainKey === "difference_sdly") {
                                let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
                                if (key.value === "Occ") {
                                    dataObj[key.value] = convertToPercent(dataRecord[0][segmentKey][dataKey1][key.value] - dataRecord[0][segmentKey][dayDateKey][key.value])
                                    totalObjData[colId][key.value] += dataObj[key.value];

                                } else {
                                    dataObj[key.value] = round(dataRecord[0][segmentKey][dataKey1][key.value] - dataRecord[0][segmentKey][dayDateKey][key.value])
                                    totalObjData[colId][key.value] += dataObj[key.value];

                                }
                            } else if (mainKey === "sdly_pickup_diff") {
                                let dayDateKey = (dayDate === "day") ? "sdly" : "sdtly";
                                let dayDate_sdly_actual = (dayDate === "day") ? "sdly_actual" : "sdtly_actual";
                                dataObj[key.value] = round(dataRecord[0][segmentKey][dayDate_sdly_actual][key.value] - dataRecord[0][segmentKey][dayDateKey][key.value])
                                totalObjData[colId][key.value] += dataObj[key.value];
                            } else if (mainKey === "marketprimary") {
                                if (key.value == "Occ") {
                                    dataObj[key.value] = 0;//convertToPercent(marketData[index]["MarketTotal"]["primary"][key.value]);
                                } else {
                                    dataObj[key.value] = 0;//round(marketData[index]["MarketTotal"]["primary"][key.value]);
                                }
                                totalObjData[colId][key.value] += dataObj[key.value];
                            } else if (mainKey === "marketsdly") {
                                if (key.value == "Occ") {
                                    dataObj[key.value] = 0;//convertToPercent(marketData[index]["MarketTotal"]["sdly"][key.value]);
                                    totalObjData[colId][key.value] += dataObj[key.value];
                                } else {
                                    dataObj[key.value] = 0;//round(marketData[index]["MarketTotal"]["sdly"][key.value]);
                                    totalObjData[colId][key.value] += dataObj[key.value];
                                }
                            } else if (mainKey === "market_sdly_diff") {
                                dataObj[key.value] = 0;//round(marketData[index]["MarketTotal"]["primary"][key.value] - marketData[index]["MarketTotal"]["sdly"][key.value])
                                totalObjData[colId][key.value] += dataObj[key.value];
                            } else {
                                if (mainKey === "primary") {
                                    mainKey = dataKey1;
                                } else if (mainKey === "pickup") {
                                    mainKey = dataKey2;
                                } else {
                                    mainKey = mainKey;
                                }
                                mainKey = getDayDateKey(dayDate, mainKey);
                                const htData = dataRecord[0]?.HotelTotal;
                                const vCapVC = htData?.[mainKey]?.VCapacity;
                                const vCap = htData?.[mainKey]?.VCapacity || htData?.[mainKey]?.Capacity;
                                const vcap = useVarCapacity ? vCap : null;
                                if (key.value == "Occ") {
                                    if (vcap) {
                                        dataObj[key.value] = convertToPercent(dataRecord[0][segmentKey][mainKey].Rooms / vcap);
                                    } else {
                                        dataObj[key.value] = convertToPercent(dataRecord[0][segmentKey][mainKey][key.value]);
                                    }
                                    if (vCap) {
                                        dataObj._vcap = useVarCapacity ? vCap : htData?.[mainKey]?.Capacity;
                                        dataObj._vcapLabel = (useVarCapacity && vCapVC) ? 'Variable Capacity' : 'Capacity';
                                        dataObj._vcapDiffers = !!(vCapVC && vCapVC !== htData?.[mainKey]?.Capacity);
                                    }
                                    totalObjData[colId][key.value] += dataObj[key.value];
                                } else if (key.value === "ADR") {
                                    dataObj[key.value] = round(dataRecord[0][segmentKey][mainKey][key.value]);
                                    primaryRoomstotal += dataRecord[0][segmentKey][mainKey]['Rooms'];
                                    primaryRevenueTotal += round(dataRecord[0][segmentKey][mainKey]['Revenue']);
                                    let adrVal = round(primaryRevenueTotal) / round(primaryRoomstotal);
                                    console.log(adrVal, " ", primaryRevenueTotal, " ", primaryRoomstotal);
                                    totalObjData[colId][key.value] = adrVal;
                                } else if (key.value === 'Available') {
                                    dataObj[key.value] = 0;
                                } else {
                                    if (key.value === 'RevPAR') {
                                        const capacity = vcap || htData?.[mainKey]?.Capacity;
                                        dataObj[key.value] = capacity ? round(dataRecord[0][segmentKey][mainKey].Revenue / capacity) : 0;
                                    } else {
                                        dataObj[key.value] = round(dataRecord[0][segmentKey][mainKey][key.value]);
                                    }
                                    if (isNaN(dataObj[key.value])) dataObj[key.value] = 0;
                                    totalObjData[colId][key.value] += checkProperValue(dataObj[key.value]);

                                }
                            }
                        })
                    }
                    data_columns.push(dataObj);
                })
                setup_data.push(data_columns);
            })

            if (!dates[dateIndex + 1] || dates[dateIndex + 1] !== date) {

                let tempArr = [];
                let totalObjDataCopy = deepCopy(totalObjData);
                // debugger;
                totalColumns.push({ id: 'staydates', date: totalObjDataCopy.date, dow: totalObjDataCopy.dow, segment: 'Total' });
                const _htTotal = dataRecord?.[0]?.HotelTotal;
                const _noVcapIndicator = ['variance_pickup', 'marketprimary', 'marketsdly', 'market_sdly_diff'];
                for (let k in totalObjDataCopy) {
                    if (k !== "date" && k !== "dow" && k !== "segment" && k !== "staydates") {
                        let tempObj = {};
                        tempObj.id = k;
                        tempObj = { ...tempObj, ...totalObjDataCopy[k] }
                        const _colMainKey = columns.find(c => c.id === k)?.mainKey;
                        // Resolve actual HotelTotal key for this column
                        let _resolvedKey = _colMainKey;
                        if (_resolvedKey === 'primary') _resolvedKey = dataKey1;
                        else if (_resolvedKey === 'pickup') _resolvedKey = dataKey2;
                        _resolvedKey = getDayDateKey(dayDate, _resolvedKey);
                        const _colVCapVC = _htTotal?.[_resolvedKey]?.VCapacity;
                        const _colVCap = _htTotal?.[_resolvedKey]?.VCapacity || _htTotal?.[_resolvedKey]?.Capacity;
                        if (_colVCap) {
                            tempObj._vcap = useVarCapacity ? _colVCap : _htTotal?.[_resolvedKey]?.Capacity;
                            tempObj._vcapLabel = (useVarCapacity && _colVCapVC) ? 'Variable Capacity' : 'Capacity';
                            if (!_noVcapIndicator.includes(_colMainKey)) {
                                tempObj._vcapDiffers = !!(_colVCapVC && _colVCapVC !== _htTotal?.[_resolvedKey]?.Capacity);
                            }
                            // variance_pickup and market columns: _vcapDiffers intentionally omitted — no VCap indicator
                        }
                        totalColumns.push(tempObj);
                    }
                }

                // if (ui_state.reports_dpbs.selectedSegment === 'All') {
                setup_data.push(totalColumns);
                // }
                totalObjData = {};
                totalObj = {};
                currentDate = date;
                totalColumns = [];
            }
        })
    }
    // console.log("here ", setup_data);
    // debugger
    return setup_data;
}


export function getPickupReportData_topSegment(columns, auth, app_state, segmentCodes, ui_state) {
    let data = (app_state.workspace_controls.segmented_view) ? [] : deepCopy(dataService.getSeriesById("OSRSegment").data.data);
    let marketData = (dataService.getSeriesById("MarketARISegmented").data) ? deepCopy(dataService.getSeriesById("MarketARISegmented").data.data) : [];

    const { active_tiles, table_filters } = ui_state;
    const filteredDow = table_filters.table_reports.dow.map(d => d.code);
    data = data.filter((item) => filteredDow.includes(moment(item.index.date).format('ddd').toLocaleLowerCase()));
    marketData = marketData.filter((item) => filteredDow.includes(moment(item.index.date).format('ddd').toLocaleLowerCase()));



    let setup_data = [];
    if (data) {
        let dataKey = "HotelTotal";
        data.map((item, index) => {
            let data_columns = [];
            columns.map(col => {
                let dataObj = {};
                if (col.type === 'dateColumn') {
                    dataObj = setUpDate(dataObj, item.index.date);
                    if (app_state.workspace_controls.segmented_view) {
                        dataObj["segment"] = item.index.segment;
                    }
                }

                if (col.type === 'dataColumn') {
                    let { mainKey } = col;
                    col.subcolumns.map(key => {
                        if (mainKey === "variance_pickup") {
                            let keyPrimaryTotalValue = getSegmentKeyTotal(item, key.value, segmentCodes, "primary", "osr");
                            let keyPickupTotalValue = getSegmentKeyTotal(item, key.value, segmentCodes, "pickup", "osr");

                            if (key.value === "Occ") {
                                dataObj[key.value] = convertToPercent(keyPrimaryTotalValue - keyPickupTotalValue)
                            } else {
                                dataObj[key.value] = round(keyPrimaryTotalValue - keyPickupTotalValue)
                            }
                        } else if (mainKey === "difference_sdly") {
                            let keyPrimaryTotalValue = getSegmentKeyTotal(item, key.value, segmentCodes, "primary", "osr");
                            let keySdlyTotalValue = getSegmentKeyTotal(item, key.value, segmentCodes, "sdly", "osr");

                            if (key.value === "Occ") {
                                dataObj[key.value] = convertToPercent(keyPrimaryTotalValue - keySdlyTotalValue)
                            } else {
                                dataObj[key.value] = round(keyPrimaryTotalValue - keySdlyTotalValue)
                            }
                        } else if (mainKey === "sdly_pickup_diff") {
                            let keySdlyActualTotalValue = getSegmentKeyTotal(item, key.value, segmentCodes, "sdly_actual", "osr");
                            let keySdlyTotalValue = getSegmentKeyTotal(item, key.value, segmentCodes, "sdly", "osr");
                            dataObj[key.value] = round(keySdlyActualTotalValue - keySdlyTotalValue)
                        }
                        else if (mainKey === "marketprimary") {
                            let keyTotalValue_market = 0;//getSegmentKeyTotal(marketData[index], key.value, segmentCodes, "primary","market");
                            if (key.value == "Occ") {
                                dataObj[key.value] = convertToPercent(keyTotalValue_market);
                            } else {
                                dataObj[key.value] = round(keyTotalValue_market);
                            }
                        } else if (mainKey === "marketsdly") {
                            let keyTotalValueSdly_market = 0;// getSegmentKeyTotal(marketData[index], key.value, segmentCodes, "primary","market");

                            if (key.value == "Occ") {
                                dataObj[key.value] = convertToPercent(keyTotalValueSdly_market);
                            } else {
                                dataObj[key.value] = round(keyTotalValueSdly_market);
                            }
                        } else if (mainKey === "market_sdly_diff") {
                            let keyTotalValue_market = 0;//getSegmentKeyTotal(marketData[index], key.value, segmentCodes, "primary","market");
                            let keyTotalValueSdly_market = 0;//getSegmentKeyTotal(marketData[index], key.value, segmentCodes, "primary","market");
                            dataObj[key.value] = round(keyTotalValue_market - keyTotalValueSdly_market)
                        }
                        else {
                            let keyTotalValue = getSegmentKeyTotal(item, key.value, segmentCodes, mainKey, "osr");
                            if (key.value == "Occ") {
                                dataObj[key.value] = convertToPercent(keyTotalValue);
                            } else {
                                dataObj[key.value] = round(keyTotalValue);
                            }
                        }
                    })
                }
                dataObj.id = col.id;
                data_columns.push(dataObj);
            })

            data_columns.map((itmArr, idx) => {
                if (itmArr['date'] == "" || itmArr['segment'] === "Total") {
                    data_columns[idx]["ignore_sort"] = true;
                }
            })
            setup_data.push(data_columns);
        })
    }
    return setup_data;
}

// function is used to calculate the total of all passed key basis on the the segement
const getSegmentKeyTotal = (item, key, segmentCodes, mainKey, segmentType = "osr", segmentTotalRow = "") => {
    let keyTotal = 0;
    let revenueTotal = 0;
    let roomsTotal = 0
    // if (segmentTotalRow === "Total" && key === 'ADR') debugger;
    if (segmentTotalRow && segmentTotalRow === "Total") {
        if (key !== "SellRate") {
            // keyTotal = item["HotelTotal"][mainKey][key];
            console.log(item, mainKey);
            let unMappedTotal = (item['Segment_UNMAPPED'] && item['Segment_UNMAPPED'][mainKey][key]) ? item['Segment_UNMAPPED'][mainKey][key] : 0;
            if (key === 'ADR' && item['Segment_UNMAPPED']) {
                let roomData = item["HotelTotal"][mainKey]['Rooms'] - item['Segment_UNMAPPED'][mainKey]['Rooms'];
                let revenueData = item["HotelTotal"][mainKey]['Revenue'] - item['Segment_UNMAPPED'][mainKey]['Revenue'];
                keyTotal = revenueData / roomData;
            } else {
                keyTotal = item["HotelTotal"][mainKey][key] - unMappedTotal;
            }
        } else {
            keyTotal = 0;
        }
        return keyTotal;
    } else {

        if (segmentCodes && segmentCodes.length > 0) {
            segmentCodes.map((code, index) => {
                let segmentCode = (segmentType === "market") ? "MarketSegment_" + code : "Segment_" + code;
                if (key === "ADR") {
                    revenueTotal += (item[segmentCode] && item[segmentCode][mainKey]["Revenue"]) ? item[segmentCode][mainKey]["Revenue"] : 0;
                    roomsTotal += (item[segmentCode] && item[segmentCode][mainKey]["Rooms"]) ? item[segmentCode][mainKey]["Rooms"] : 0;
                } else {
                    keyTotal += (item[segmentCode] && item[segmentCode][mainKey][key]) ? item[segmentCode][mainKey][key] : 0;
                }
            })
            if (key === "ADR") {
                keyTotal = revenueTotal / roomsTotal;
            }
            return keyTotal;
        }

    }

}